export const firebaseConfig = {
   apiKey: 'AIzaSyBGWM7WmPq6I7IBR4kAdLZPLfVAitxbHC0',
   // Named Firestore database this project's data actually lives in. MUST stay in
   // sync with FIRESTORE_DATABASE_ID in functions/.env.<project> — the functions
   // read and write there, so a client left on '(default)' subscribes to an empty
   // database and silently never receives an update.
   databaseId: 'oopsy-app',
   authDomain: 'oopsy-app.firebaseapp.com',
   projectId: 'oopsy-app',
   storageBucket: 'oopsy-app.appspot.com',
   messagingSenderId: '409861724524',
   appId: '1:409861724524:web:e35c358660ff324debfb49',
   measurementId: 'G-5W5PBWZGNN',
   recaptchaSiteKey: '6LccydksAAAAAL91ibusfIn-ydywkVmTZ1EVfBM0',
};
